---@meta

---@class Storage
---@field get fun(self: Storage, key: string): any
---@field set fun(self: Storage, key: string, value: any): string
---@field unset fun(self: Storage, key: string): string
---@field exists fun(self: Storage, key: string): boolean

storage = {} ---@type Storage
